import { makeStyles } from '@material-ui/core';

export default makeStyles({
  toppingList: {
    fontSize: '0.75rem',
    margin: '0 0 0.125rem 1.5em',
    listStyleType: 'none',
    listStylePosition: 'inside',
    '&[data-toppings-level="0"]': {
      marginLeft: '1em',
    },
    '@container orderInvoicePrinting (width >= 48mm)': {
      '&[data-toppings-level="0"]': {
        marginLeft: '1.875em',
      },
    },
  },
});
